import { Box, Container, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { PO_Backlog_Service } from "../../redux/po_backlog/po_backlog.services";
import TopBar from "./components/TopBar";
import ApproverTabContent from "./components/TabContent";



const ApproverHome = () => {
    const [tabValue, setTabValue] = useState(0);
    const [tabs, setTabs] = useState([]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const fetchTabs = async () => {
        try {
            const result = await PO_Backlog_Service.sample_types_get();
            // console.log(result);
            if (Array.isArray(result?.data?.data)) {
                setTabs(result?.data?.data);
            } else if (typeof result?.data?.data === "object") {
                setTabs(Object.keys(result.data?.data));
            } else {
                console.error("Unexpected data structure:", result?.data);
                setTabs([]);
            }
        } catch (error) {
            console.error(error);
            setTabs([]);
        }
    };

    useEffect(() => {
        fetchTabs();
    }, []);

    return (
        <Box className="">
            <Box className="flex flex-col gap-3 p-2">
                <TopBar />
            </Box>
            <Container maxWidth="xl">
                <Box className="flex justify-between items-baseline">
                    <Tabs
                        className="flex-1"
                        sx={{
                            borderBottom: "1px solid #e8e8e8",
                            "& .MuiTabs-indicator": {
                                backgroundColor: "#084298",
                                display: "flex",
                                justifyContent: "center",
                            },
                            "& .MuiTabs-indicatorSpan": {
                                maxWidth: 40,
                                width: "100%",
                                // backgroundColor: '#635ee7',
                            },
                        }}
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons={false}
                        aria-label="scrollable prevent tabs example"
                    >
                        {tabs?.map((tab, index) => (
                            <Tab key={index} disableRipple label={(tab === "CB" ? "In Process" : tab === "FP" ? "FP Pack" : tab)} />
                        ))}
                    </Tabs>
                    <Box></Box>
                </Box>
                {/* Render content based on the selected tab */}
                <ApproverTabContent tabName={tabs[tabValue]} />
            </Container>
        </Box>
    );
};

export default ApproverHome;
